import HeaderFooterLayout from 'layouts/HeaderFooterLayoutAdmin';
import React from 'react';
import MonthlyGoals from '../components/AdminPanel/MonthlyGoals';

const AdminMonthlyGoalsPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <MonthlyGoals {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdminMonthlyGoalsPage;
